import styled from "styled-components";
import PretendardText from "../../../../component/atoms/text/pretendardText";
import { useQuery } from "@tanstack/react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import BoardApi from "../../../../api/board.api";
import { errorHandler } from "../../../../util/errorHandler";
import { minToMs } from "../../../../util/formatMs";
import Loading from "../../../../component/templates/Loading";
import { route } from "../../../../router/route";
import Pagination from "../../../../component/molecules/pagination";
import { useEffect, useState } from "react";
import Empty from "../../../../component/molecules/empty";
import Pagination2 from "../../../../component/molecules/pagination2";

const AskList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathName = location.pathname;
  let { id } = useParams();

  const [currentPage, setCurrentPage] = useState(1);

  const [pagination, setPagination] = useState({
    size: 1, // 한 페이지에 표시될 게시글 수
    rangeSize: 5, // 하단 페이지 사이즈
    totalCount: 0,
    totalPages: 0,
    first: false,
    last: false,
  });

  const [askList, setAskList] = useState([]);

  const getAskList = async () => {
    const data = {
      page: Number(currentPage),
      size: Number(pagination.size),
      boardPostType: "ASK",
      memberId: id,
    };

    const response = (await BoardApi.getListBoard(data)).data.data;

    setPagination({
      ...pagination,
      totalCount: response.totalCount,
      totalPages: Math.ceil(response.totalCount / pagination.size),
    });

    setAskList(response.content);
  };

  useEffect(() => {
    getAskList();
  }, [currentPage]);

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <AskContainer>
          <AskHeader>
            <PretendardText
              style={{
                color: "#f3f3f3",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "28px",
                letterSpacing: "-0.3%",
              }}
            >
              1:1 문의 내역
            </PretendardText>
          </AskHeader>
          <div
            style={{
              width: "100%",
              height: "fit-content",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRadius: "10px",
              background: "#272829",
              boxShadow: "2px 2px 10px 0px rgba(0, 0, 0, 0.08)",
            }}
          >
            {askList.map((item, index) => {
              return (
                <div
                  key={index}
                  style={{
                    width: "100%",
                    height: 59,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0px 15px",
                    borderBottom:
                      askList.length - 1 === index
                        ? "none"
                        : "0.5px solid rgba(255, 255, 255, 0.12)",
                  }}
                >
                  <PretendardText
                    className="truncate"
                    style={{
                      width: 450,
                      color: "#aaa",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "22px",
                      letterSpacing: "-0.3%",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      navigate(`${route.operation_ask_detail}/${item.id}`);
                    }}
                  >
                    {item?.title || ""}
                  </PretendardText>

                  <PretendardText
                    style={{
                      color: "#aaa",
                      fontSize: "14px",
                      fontWeight: 500,
                      lineHeight: "22px",
                      letterSpacing: "-0.3%",
                    }}
                  >
                    {item?.answerStatus ? "답변완료" : "미답변"}
                  </PretendardText>
                </div>
              );
            })}
          </div>

          {askList.length > 0 ? null : (
            <Empty style={{ borderBottom: "none" }} />
          )}
        </AskContainer>

        {/* 페이지네이션 영역 */}
        <Pagination2
          style={{ width: 265, marginTop: 28 }}
          route={``}
          queryString={``}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={pagination.totalPages}
          rangeSize={pagination.rangeSize}
          first={pagination.first}
          last={pagination.last}
        />
      </div>
    </>
  );
};

export default AskList;

const AskContainer = styled.div.attrs((props) => {})`
  width: 534px;
  height: fit-content;
  min-height: 565px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px;
  background: #272829;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
`;

const AskHeader = styled.div.attrs((props) => {})`
  width: 100%;
  height: 59px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
`;
